import { render, staticRenderFns } from "./ActivityDetails.vue?vue&type=template&id=4b00f400"
import script from "./ActivityDetails.vue?vue&type=script&lang=js"
export * from "./ActivityDetails.vue?vue&type=script&lang=js"
import style0 from "./ActivityDetails.vue?vue&type=style&index=0&id=4b00f400&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports